module.exports = __webpack_public_path__ + "img/connectIcon.e0c6ae50.svg";